export const ROUTES = {
  HOME: "/",
  SESSION: "/session",
  SESSION_VIEW: "/session/:id",
  PROFILE: "/profile",
  PROFILE_CHANGE_PASSWORD: "/profile/change-password",
  PROFILE_FINDINGS: "/profile/findings",
  PROFILE_CATEGORIES: "/profile/categories",
  PROFILE_TEMPLATES: "/profile/templates",
  PROFILE_REPORT_TEMPLATES: "/profile/report-templates",
  PROFILE_REPORT_TEMPLATE: "/profile/report-templates/:id",
  PROFILE_REPORT_TEMPLATE_NEW: "/profile/report-templates/new",
  SUBSCRIPTION: "/subscription",
  CHECKOUT: "/checkout",
} as const;

export const SESSION_STATUS = {
  CREATED: 1,
  RECORDED: 2,
  COMPLETED: 3,
  CANCELLED: 4,
} as const;

export const BILLING_CYCLES = {
  MONTHLY: 1,
  YEARLY: 2,
} as const;
